import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "sabreSegment",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.SABRE_SEGMENT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.SABRE_SEGMENT.PERMISSIONS,
    },
    component: () => import("@/modules/SabreSegment/views/sabreSegment.vue"),
  },
];

export default routes;
